import React,{useState,useEffect} from "react";
import { HeaderComponent, ImageSlider,Experience, HomeService, PatientFeedback, Map, LatestOffers } from "../../FourthComponents";

const FourthHome = (props) => {
    const { selectedLanguage } = props;
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div className={isHeaderFixed ? "frth-design-screens-main" : ""}>
            <ImageSlider {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_welcome_to_cairo_capital_clinics} text={selectedLanguage?.txt_health_care_is_a_constant_form_of_collaboration_and_innovation}/>
            <Experience {...props}/>
            <HeaderComponent title={selectedLanguage?.our_services_heading} text={selectedLanguage?.txt_this_is_a_sample_of_our_services}/>
            <HomeService {...props}/>
            <PatientFeedback {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_latest_offers} />
            <LatestOffers {...props}/>
            <Map/>
        </div>
    )
}

export default FourthHome